function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 295 142",
    xmlns: "http://www.w3.org/2000/svg",
    xlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    serif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "arrow",
    transform: "matrix(1,0,0,1,85,-3.15)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,15.772L12.622,3.15L83.222,73.75L12.622,144.35L0,131.726L57.976,73.749L0,15.772Z",
    style: {
      fill: "url(#_Linear1)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "arrow-2",
    transform: "matrix(1,0,0,1,126.611,-3.15)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,15.772L12.622,3.15L83.222,73.75L12.622,144.35L0,131.726L57.976,73.749L0,15.772Z",
    style: {
      fill: "url(#_Linear2)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "arrow-3",
    transform: "matrix(1,0,0,1,170,-3.15)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,15.772L12.622,3.15L83.222,73.75L12.622,144.35L0,131.726L57.976,73.749L0,15.772Z",
    style: {
      fill: "url(#_Linear3)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "arrow-4",
    transform: "matrix(1,0,0,1,211.611,-3.15)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,15.772L12.622,3.15L83.222,73.75L12.622,144.35L0,131.726L57.976,73.749L0,15.772Z",
    style: {
      fill: "url(#_Linear4)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "arrow-5",
    transform: "matrix(1,0,0,1,0,-3.15)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,15.772L12.622,3.15L83.222,73.75L12.622,144.35L0,131.726L57.976,73.749L0,15.772Z",
    style: {
      fill: "url(#_Linear5)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "arrow-6",
    transform: "matrix(1,0,0,1,41.611,-3.15)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,15.772L12.622,3.15L83.222,73.75L12.622,144.35L0,131.726L57.976,73.749L0,15.772Z",
    style: {
      fill: "url(#_Linear6)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear1",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(7.38369e-15,120.585,-120.585,7.38369e-15,41.611,15.4344)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "black",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    style: {
      stopColor: "rgb(0,69,255)",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "black",
      stopOpacity: 0.3
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear2",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(7.38369e-15,120.585,-120.585,7.38369e-15,41.611,15.4344)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "black",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    style: {
      stopColor: "rgb(0,69,255)",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "black",
      stopOpacity: 0.3
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear3",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(7.38369e-15,120.585,-120.585,7.38369e-15,41.611,15.4344)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "black",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    style: {
      stopColor: "rgb(0,69,255)",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "black",
      stopOpacity: 0.3
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear4",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(7.38369e-15,120.585,-120.585,7.38369e-15,41.611,15.4344)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "black",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    style: {
      stopColor: "rgb(0,69,255)",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "black",
      stopOpacity: 0.3
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear5",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(7.38369e-15,120.585,-120.585,7.38369e-15,41.611,15.4344)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "black",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    style: {
      stopColor: "rgb(0,69,255)",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "black",
      stopOpacity: 0.3
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear6",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(7.38369e-15,120.585,-120.585,7.38369e-15,41.611,15.4344)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "black",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    style: {
      stopColor: "rgb(0,69,255)",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "black",
      stopOpacity: 0.3
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.87ae5d46d519116f1fedd507da999f83.svg";
export { ForwardRef as ReactComponent };